module.exports = __webpack_public_path__ + "assets/img/cl_icon_white.c2e171ef.svg";